import React from "react";

import styled from "styled-components/macro";

import { CenteredUnstyledButton } from "components/Button/UnstyledButton";
import { CommentIcon } from "components/Comments/Icon";
import { Column } from "components/Layout";

export const saleLotCommentsColumnId = "saleLotCommentCount";
const SizedColumn = styled(Column)`
  font-size: 0.8em;
  line-height: 30px;
`;

interface SaleLotCommentCountColumnRendererProps {
  value: number | string | null | undefined;
  data: {
    resolvedCommentCount: number;
    unResolvedCommentCount: number;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- ag-grid row data
    [key: string]: any;
  };
  context: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- ag-grid row data
    handleClickSaleLotComments: (data: any) => void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- ag-grid context
    [key: string]: any;
  };
}

export function saleLotCommentCountColumnRenderer(
  props: SaleLotCommentCountColumnRendererProps,
): React.JSX.Element {
  const { value, data, context } = props;
  if (value === undefined || value === null || typeof value === "string") {
    return null;
  }
  const { handleClickSaleLotComments } = context || {};
  const { resolvedSaleLotCommentCount } = data;
  let body = (
    <CommentIcon
      hasUnresolvedComments={value > 0}
      hasResolvedComments={resolvedSaleLotCommentCount > 0}
      internalText={value}
      size="2x"
    />
  );

  if (typeof handleClickSaleLotComments === "function") {
    body = (
      <CenteredUnstyledButton onClick={() => handleClickSaleLotComments(data)}>
        {body}
      </CenteredUnstyledButton>
    );
  }
  return (
    <SizedColumn justifyCenter alignCenter fullHeight fullWidth>
      {body}
    </SizedColumn>
  );
}

interface CommentCountColumnRendererProps {
  value: number | string | null | undefined;
  data: {
    resolvedCommentCount: number;
    unResolvedCommentCount: number;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- ag-grid row data
    [key: string]: any;
  };
  context: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- ag-grid row data
    handleClickComments: (data: any) => void;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- ag-grid context
    [key: string]: any;
  };
}

export function CommentCountColumnRenderer(
  props: CommentCountColumnRendererProps,
): React.JSX.Element {
  const { value, data, context } = props;
  if (value === undefined || data === undefined) {
    return null;
  }
  const { handleClickComments } = context || {};
  const { resolvedCommentCount, unResolvedCommentCount } = data;
  let body = (
    <CommentIcon
      hasUnresolvedComments={unResolvedCommentCount > 0}
      hasResolvedComments={resolvedCommentCount > 0}
      internalText={value}
      size="2x"
    />
  );

  if (typeof handleClickComments === "function") {
    body = (
      <CenteredUnstyledButton onClick={() => handleClickComments(data)}>
        {body}
      </CenteredUnstyledButton>
    );
  }

  return (
    <SizedColumn justifyCenter alignCenter fullHeight fullWidth>
      {body}
    </SizedColumn>
  );
}
